
// @flow

import { RestClientAuthenticated } from '../network';

const visioGlobeApi = {
  fetchHashmap: (pcId: string) => new RestClientAuthenticated(`/api/visio-globe/hashmap/${pcId}`, 'GET').addParam('type', 'VISIOWEB').execute(),
};

export default visioGlobeApi;
